let data4=[
    {
        id:0,
        imgUrl:"img/blog1.jpg",
        comment:"comment",
        title:"Fusce vel ipsum ut est lobortis tincidunt a sit amet sapien",
        contents:"Sed condimentum ipsum et felis euismod blandit. Ut in turpis eu justo..."
    },
    {
        id:1,
        imgUrl:"img/blog2.jpg",
        comment:"comment",
        title:"Nullam Vel Sodales OrciAliquam Lacinia Quam Sit Amet Sapien",
        contents:"Cras efficitur semper leo ac sagittis. Aliquam erat volutpat. Phasellus accumsan malesuada..."
    },

    {
        id:2,
        imgUrl:"img/blog3.jpg",
        comment:"comment",
        title:"Duis tincidunt ante sit amet bibendum blandit",
        contents:"Vivamus ac lorem quis mauris dignissim luctus eu at erat. Vestibulum nec..."

    }
]

export default data4;